<template>
  <Dialog
    :model-value="visible"
    title="Delete Block"
    dialog-type="error"
    dialog-size="small"
    :close-on-overlay="false"
    :header-icon-src="require('@/assets/MyWorkBench/Workflow/delete_button_prefix.svg')"
    @update:model-value="(v) => { if (!v) closeDialog() }"
    @close="closeDialog"
  >
    <p class="warning-text">
      Are you sure you want to delete the <strong>{{ nodeName }} block</strong>? This action cannot be undone.
    </p>

    <template #footer>
      <ResponsiveButton button_type="outlined" built_in_theme="error" size="medium" @click="closeDialog">Cancel</ResponsiveButton>
      <ResponsiveButton button_type="filled" built_in_theme="error" size="medium" @click="confirmDelete">Delete</ResponsiveButton>
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'DeleteNodeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    nodeName: {
      type: String,
      default: 'Node Name'
    }
  },
  emits: ['close', 'delete'],
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    confirmDelete() {
      this.$emit('delete');
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.warning-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  color: #374957;
  margin: 0;
  padding: 16px 8px;
}
</style>
